import settings from '@/config/settings';

import {EApiRequestMethod} from '@/assets/core/assets/api/enums';

import {keycloakAPI} from '@/assets/keycloak';

const getEmptyBlob = () => {
  const url =
    'data:image/png;base64,' +
    'iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqc' +
    'GAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAfSURBVHic7cEBDQAAAMKg909tDjegAAAAAAAAAAC+' +
    'DSEAAAHxZyHuAAAAAElFTkSuQmCC\n';

  return fetch(url).then((res) => res.blob());
};

export const loadAPIImage = async (
  url: URL | string,
  headers: Record<string, string> = {},
): Promise<Blob> => {
  if (!settings.APP.TEST) {
    if (keycloakAPI.getKeycloak.value.isTokenExpired()) {
      await keycloakAPI.getKeycloak.value.updateToken(-1);
    }
    if (keycloakAPI.getToken.value != null) {
      headers['Authorization'] = 'Bearer ' + keycloakAPI.getToken.value;
    }
  }

  const initConfig: RequestInit = {
    method: EApiRequestMethod.GET,
    credentials: 'include',
    mode: 'cors',
    headers: headers,
    signal: new AbortController().signal,
  };

  return await fetch(url, initConfig).then((response) => {
    if (response.ok) {
      if (response.status === 204) return getEmptyBlob();
      else return response.blob();
    } else {
      throw 'error';
    }
  });
};
